const STORES = ['Coles', 'Woolworths', 'Aldi'];
const STORE_COLOR = { Coles: '#E50016', Woolworths: '#129C4F', Aldi: '#001E5E' };
const STORE_LIGHT = { Coles: '#fdeaec', Woolworths: '#e8f8ee', Aldi: '#e6e9f3' };

export default function StoreGroupingView({ items, prices }) {
  // Assign each item to the store with the best price
  const groups = { Coles: [], Woolworths: [], Aldi: [], none: [] };

  for (const item of items) {
    const itemPrices = prices?.[item.name];
    if (!itemPrices) { groups.none.push({ item, price: null, store: null }); continue; }

    const storePriceList = STORES.map(s => ({ store: s, price: itemPrices[s]?.price ?? null }))
      .filter(x => x.price !== null);

    if (!storePriceList.length) { groups.none.push({ item, price: null, store: null }); continue; }

    storePriceList.sort((a, b) => a.price - b.price);
    const best = storePriceList[0];
    const worst = storePriceList[storePriceList.length - 1];
    const saving = worst.price - best.price;

    groups[best.store].push({ item, price: best.price, store: best.store, saving });
  }

  return (
    <div className="sgv-wrap">
      <div className="sgv-cols">
        {STORES.map(store => (
          <div key={store} className="sgv-col" style={{ '--sgv-color': STORE_COLOR[store], '--sgv-light': STORE_LIGHT[store] }}>
            <div className="sgv-col-header" style={{ background: STORE_COLOR[store] }}>
              <span>{store}</span>
              <span className="sgv-col-count">{groups[store].length}</span>
            </div>
            {groups[store].length === 0 ? (
              <p className="sgv-empty">No best prices here</p>
            ) : (
              <ul className="sgv-items">
                {groups[store].map(({ item, price, saving }) => (
                  <li key={item.id} className="sgv-item">
                    <span className="sgv-item-name">{item.name}</span>
                    <div className="sgv-item-right">
                      <span className="sgv-item-price">${price.toFixed(2)}</span>
                      {saving > 0.01 && (
                        <span className="sgv-item-save">save ${saving.toFixed(2)}</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      {groups.none.length > 0 && (
        <div className="sgv-none">
          <p className="sgv-none-title">No price data found for:</p>
          <p className="sgv-none-items">{groups.none.map(x => x.item.name).join(', ')}</p>
        </div>
      )}
    </div>
  );
}
